<template>
  <div class="content">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="20%">
      <div class="radio-content">
        <el-radio v-model="radio" :label="val" v-for="(val,index) in radioList" :key="index"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="own_red_plain_button" @click="dialogVisible = false">取 消</div>
        <div class="own_red_button" @click="confirm">确 定</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {report} from '@/api/interfaceApi'

export default {
  data() {
    return {
      dialogVisible: false,
      radioList: [
        '内容违法', '重复、旧闻', '色情低俗', '与事实不符', '广告', '侵犯名誉/商誉/肖像/隐私权'
      ],
      radio: ''
    }
  },
  computed: {},
  props: {
    title: {
      type: String,
      default: '提示'
    },
    //举报类型 1文章 2视频 3圈子文章
    type: {
      type: [String, Number],
      default: 1
    },
    //举报的文章或视频的ID
    article_id: {
      type: [String, Number],
      default: 0
    }
  },
  mounted() {
  },
  methods: {
    //打开弹窗
    open() {
      this.dialogVisible = true
    },
    //关闭弹窗
    close() {
      this.dialogVisible = false
    },
    //确认
    confirm() {
      if (this.radio == '') {
        this.$message.error('请选择举报内容')
        return
      }
      if (this.article_id == 0) {
        this.$message.error('内容错误')
        return
      }
      let cid=sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      report({
        article_id: this.article_id,
        type: this.type,
        content: this.radio,
        uid: cid!=0 && cid!=undefined ? cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('举报成功')
          this.close();
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.own_red_button {
  display: inline-block;
  width: 78px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #FE273B;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;

  font-weight: 400;
  color: #FFFFFF;
  margin-left: 20px;
}

.own_red_plain_button {
  display: inline-block;
  width: 78px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #DDDDDD;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;

  font-weight: 400;
  color: #333333;
}
</style>
<style scoped>
.radio-content >>> .el-radio {
  width: 100%;
  padding: 10px 0;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.radio-content >>> .el-radio__label {
  font-size: 16px;
}

.content >>> .el-dialog__body {
  border-top: 1px solid #EEEEEE;
  padding: 16px 20px 30px;
  color: #333333;
  font-size: 14px;
  word-break: break-all;
}

.content >>> .el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: 600;
}

.radio-content >>> .el-radio__input.is-checked + .el-radio__label {
  color: #F56C6C;
}

.radio-content >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #F56C6C;
  background: #F56C6C;
}
</style>